import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { getBannerIcon } from './util.js';
import { IconButton } from '../IconButton/IconButton.js';

var Banner = /*#__PURE__*/forwardRef(function Banner(props, ref) {
  var children = props.children,
      state = props.state,
      onClose = props.onClose;
  var className = cn('yt-banner flex ', props.className);
  return createElement("div", {
    className: className,
    ref: ref
  }, getBannerIcon(state), children, onClose ? createElement(IconButton, {
    className: "ml-auto",
    icon: "close",
    appearance: "discrete",
    onClick: onClose
  }) : null);
});

export { Banner };
//# sourceMappingURL=Banner.js.map
